import { notification } from 'antd';

type NotificationType = 'success' | 'info' | 'warning' | 'error';

export const Notification = (
  type: NotificationType,
  message: string,
  description: string
): void => {
  notification[type]({
    message,
    description,
    duration: 3,
  });
};